import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@saucelabs/sl-component-form';

import Styles from './SelectAllItem.styles';

const SelectAllItem = ({ onCheckboxUpdate }) => (
  <div className={Styles['checkbox-container']}>
    <Checkbox
      className={Styles['select-all-checkbox']}
      onChange={onCheckboxUpdate}
    >
      <span className={Styles['checkbox-text']}>
        Select All
      </span>
    </Checkbox>
  </div>
);

SelectAllItem.propTypes = {
  onCheckboxUpdate: PropTypes.func.isRequired,
};

export default SelectAllItem;
